"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QueueMessageTypeRelation = void 0;

var common_enums_1 = require("@ryerson/common.enums");

exports.QueueMessageTypeRelation = [{
  queueName: common_enums_1.QueueEnum.QueueName.Orders,
  messageTypes: [common_enums_1.QueueEnum.MessageType.IQ_ORDER_UPDATE, common_enums_1.QueueEnum.MessageType.ECOM_ORDER_CREATE]
}, {
  queueName: common_enums_1.QueueEnum.QueueName.Communications,
  messageTypes: [common_enums_1.QueueEnum.MessageType.EMAIL_SEND, common_enums_1.QueueEnum.MessageType.SENDGRID_EVENT]
}, {
  queueName: common_enums_1.QueueEnum.QueueName.Quotes,
  messageTypes: [common_enums_1.QueueEnum.MessageType.ECOM_QUOTE_CREATE, common_enums_1.QueueEnum.MessageType.ECOM_CONVERT_QUOTE_TO_ORDER, common_enums_1.QueueEnum.MessageType.IQ_QUOTE_APPROVE, common_enums_1.QueueEnum.MessageType.IQ_QUOTE_CREATE, common_enums_1.QueueEnum.MessageType.IQ_QUOTE_DELETE, common_enums_1.QueueEnum.MessageType.IQ_QUOTE_UPDATE]
}, {
  queueName: common_enums_1.QueueEnum.QueueName.Errors,
  messageTypes: [common_enums_1.QueueEnum.MessageType.ERROR_MESSAGE]
}, {
  queueName: common_enums_1.QueueEnum.QueueName.Invoices,
  messageTypes: [common_enums_1.QueueEnum.MessageType.INVOICE_PAYMENT]
}];